export const JOIN_PTA_URL = "https://www.ashleyfallspta.com/membership";

export const ASSETS = {
  logo: "https://customer-assets-agu9un31.emergentagent.net/job_8ee0f295-a6d4-48b6-822c-a3c49a0cc849/artifacts/fonn4ifa_Ashley-Falls-PTA-Logo.png",
  plushie: "https://customer-assets-agu9un31.emergentagent.net/job_8ee0f295-a6d4-48b6-822c-a3c49a0cc849/artifacts/4yxwl7ec_Plushie%20Mockup.png",
  mascot: "https://customer-assets-agu9un31.emergentagent.net/job_8ee0f295-a6d4-48b6-822c-a3c49a0cc849/artifacts/7lr5tieh_Soaring%20to%20Success%20Glowing%20Eagle.webp",
  kahootsMascot: "https://customer-assets-cm19k8pv.emergentagent.net/job_retro-survey-flow/artifacts/geci9shj_Picture83.png",
  unpluggedEagle: "https://customer-assets-cm19k8pv.emergentagent.net/job_retro-survey-flow/artifacts/6syhk4fp_Eagle%20Unplugged.png",
};

const VOLUNTEER_CHOICES = ["Yes, interested", "Not at this time", "I'd like to learn more"];

export const STEPS = [
  { id: "intro", type: "intro" },
  { id: "volunteer_intro", type: "volunteer_intro" },
  {
    id: "bucket_1_leadership_planning",
    type: "choice",
    kicker: "Volunteer · Bucket 1 of 5",
    title: "Leadership & Planning",
    tagline: "The creative directors!",
    text: "Help brainstorm themes, organize logistics, and guide our events from concept to reality. If you're an amazing party planner, this is where you will shine.",
    choices: VOLUNTEER_CHOICES,
    accent: "cyan",
  },
  {
    id: "bucket_2_event_setup",
    type: "choice",
    kicker: "Volunteer · Bucket 2 of 5",
    title: "Event Setup",
    tagline: "The magic makers!",
    text: "Help transform our school spaces right before the doors open. Hang out on campus and let your creativity shine.",
    choices: VOLUNTEER_CHOICES,
    accent: "pink",
  },
  {
    id: "bucket_3_event_breakdown",
    type: "choice",
    kicker: "Volunteer · Bucket 3 of 5",
    title: "Event Breakdown",
    tagline: "The wrap-up crew!",
    text: "Many hands make light work. Help us pack up decorations and restore the school. Perfect for the 'doers' who can get the job done.",
    choices: VOLUNTEER_CHOICES,
    accent: "yellow",
  },
  {
    id: "bucket_4_at_home_heroes",
    type: "choice",
    kicker: "Volunteer · Bucket 4 of 5",
    title: "At-Home Heroes",
    tagline: "Support the PTA on your own schedule!",
    text: "Bake treats, cut out flyers, or paint decorations from the comfort of your own couch.",
    choices: VOLUNTEER_CHOICES,
    accent: "cyan",
  },
  {
    id: "bucket_5_logistics_prep",
    type: "choice",
    kicker: "Volunteer · Bucket 5 of 5",
    title: "Logistics & Prep",
    tagline: "The treasure hunters!",
    text: "Run errands on your own time to pick up event supplies, snacks, or grab necessary items before the big day.",
    choices: VOLUNTEER_CHOICES,
    accent: "pink",
  },
  { id: "transition", type: "transition" },
  {
    id: "unplugged_screen_time",
    type: "choice",
    kicker: "Eagles Unplugged · 1 of 3",
    title: "Screen Time",
    text: "On a typical weekday, how many hours of non-school/recreational screen time does your child spend daily?",
    choices: ["Less than 1 hour", "1-2 hours", "3-4 hours", "5+ hours"],
    accent: "cyan",
  },
  {
    id: "unplugged_bedtime",
    type: "choice",
    kicker: "Eagles Unplugged · 2 of 3",
    title: "Bedtime",
    text: "Does your child typically have screens or devices in their bedroom after bedtime?",
    choices: ["Never", "Sometimes", "Always", "N/A"],
    accent: "pink",
  },
  {
    id: "unplugged_boundaries",
    type: "choice",
    kicker: "Eagles Unplugged · 3 of 3",
    title: "Boundaries",
    text: "How challenging is it to manage screen time boundaries or encourage offline activities in your household?",
    choices: ["Easy", "Moderate", "Very Challenging"],
    accent: "yellow",
  },
  { id: "contact", type: "contact" },
];

export const SOCIAL_PROOF_MESSAGES = [
  "A parent in 2nd Grade just completed the survey 2 mins ago!",
  "Someone just earned 50 entries!",
  "A Kindergarten mom just finished in 28 seconds!",
  "A 4th Grade dad just earned 50 entries!",
  "3 parents completed the survey in the last 10 minutes!",
  "A parent in 1st Grade just joined the plushie drawing!",
  "A 5th Grade family just earned 50 entries!",
  "A 3rd Grade parent signed up to volunteer!",
];
